import gql from 'graphql-tag';

export const SelectBillingPlanMutation = gql`
  mutation selectBillingPlan($account: ID!, $plan: String!) {
    selectBillingPlan(account: $account, plan: $plan)
  }
`;